export default __webpack_public_path__ + "static/supplies-474f319dbe1d49ef657641d2229906f8.png";